import { useCallback } from "react";
import { getTelegram } from "../telegram";

type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft";
type Notification = "error" | "success" | "warning";

export function useHaptic() {
  const impact = useCallback((style: ImpactStyle = "light") => {
    getTelegram()?.HapticFeedback?.impactOccurred(style);
  }, []);
  const notify = useCallback((type: Notification) => {
    getTelegram()?.HapticFeedback?.notificationOccurred(type);
  }, []);
  const select = useCallback(() => {
    getTelegram()?.HapticFeedback?.selectionChanged();
  }, []);
  return { impact, notify, select };
}
